import { useState, useEffect } from "react";
import axios from "axios";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Vehicle.scss";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import { Link } from "react-router-dom";
import city from '../../../city.json'


const Vehicle = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [vehicleData, setVehicleData] = useState({});
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
    const [location, setLocation] = useState("Kolkata");


// temporary values (for input fields)
const [tempYear, setTempYear] = useState(currentYear);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchVehicleMuhurat = async () => {
      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/VehiclePurchase-Muhurat?year=${year}&location=${encodeURIComponent(location)}`
        );
        setVehicleData(response.data?.vehiclePurchaseMuhurat || {});
      } catch (error) {
        console.error("Failed to fetch vehicle muhurat data:", error);
      }
    };

    fetchVehicleMuhurat();
  }, [year, location]);

  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const monthKeys = Object.keys(vehicleData);
    const handleSubmit = () => {
  setYear(tempYear);
  setLocation(tempLocation);
};


  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };


  return (
    <div className="Vehicle-container">
      <InnerNav />
      <div className="Vehicle-content">
        <Zodiac />
       <div className="location-date">
       <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

       <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
          </div>
          <div className="meaning">
          <p className="meaning1">⚠️: Not Recommended / Ashubh Muhurat</p>
        <p className="meaning1">✅: Shubh Muhurat</p>
      </div>
        <h1 className="Vehicle-title">Vehicle Purchase Muhurat</h1>

        {monthKeys.length > 0 ? (
          monthKeys.map((month, index) => {
            const isExpanded = expandedMonths[index];
            const events = vehicleData[month] || [];
            const visibleVehicle = isExpanded ? events : events.slice(0, 6);

            return (
              <div className="monthVehicle" key={index}>
                <h2 className="month-heading">{month}, {year}</h2>
                <div className="list-of-Vehicle">
                  {visibleVehicle.map((item, i) => (
                    <div className="Vehicle-card" key={i}>
                      <div className="Vehicle-info">
                        <p className="tag">{item.tag ? item.tag.slice(0, 2) : ""}</p>
                        <p><strong>Date:</strong> {formatDate(item.date)}</p>
                        {item.weekday && <p><strong>Weekday:</strong> {item.weekday}</p>}
                        {item.tithi && <p><strong>Tithi:</strong> {item.tithi}</p>}
                        {item.nakshatra && <p><strong>Nakshatra:</strong> {item.nakshatra}</p>}
                        {item.verdict && <p><strong>Verdict:</strong> {item.verdict}</p>}
                        {item.rating && <p><strong>Rating:</strong> {item.rating}</p>}
                        {item.score !== undefined && <p><strong>Score:</strong> {item.score}</p>}
                      </div>
                    </div>
                  ))}
                </div>

                {events.length > 6 && (
                  <button className="toggle-btn" onClick={() => handleToggle(index)}>
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p>No Vehicle Purchase Muhurat data available for {year}.</p>
        )}
        
         <section className="vivah-wrapper">
          <h1 className="vivah-title">About Property Purchase</h1>
          <div className="vivah-texts">
            <p>
            Auspicious dates to purchase any vehicle like car, scooter, or bike are calculated after doing Panchang Shuddhi or Panchangam Shuddhi. Panchang Shuddhi provides not only auspicious dates but also Shubh timings to buy a vehicle.

            All available auspicious dates to purchase a vehicle in the year 2025 are determined after doing Weekday, Nakshatra, and Tithi Shuddhi for all days of the year. Auspicious timings that start after late night (after 9 p.m.) are generally discarded.

            Movable Nakshatras such as Punarvasu, Swati, Shravana, Dhanishtha, and Shatabhisha are considered the best for purchasing a car or any other vehicle. Other Nakshatras, which are regarded as sweet and small, are also favorable for driving an automobile for the first time.

            All published times should be supported with an 
            <Link to="/muhurat/auspicious-yoga" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
             Auspicious Lagna
          </Link>. Chara and Dwiswabhava Lagna are especially good for buying and driving a new vehicle. Mesha, Karka, Tula, and Makara are Chara Lagna, while Mithuna, Kanya, Dhanu, and Meena are Dwiswabhava Lagna. 
          <Link to="/muhurat/rahu-kala" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Rahu Kala
          </Link> should be avoided if it overlaps with the published timings.

            Only those Muhurats which prevail for at least 5 minutes are considered, while those lasting less than 5 minutes are discarded. Muhurats are calculated from Sunrise to Sunrise. If a 24+ time format is selected, then Muhurat timings extending beyond midnight are shown in the 24+ format.

            All auspicious dates and timings to buy a vehicle are location-based, and it is important to set the city first before noting down Shubh dates and timings for vehicle purchase.
            </p>
          </div>
        </section>
        <MuhuratLink />
      </div>
      <Footer />
    </div>
  );
};

export default Vehicle;
